import { useScrollReveal } from "@/hooks/useScrollReveal";

const businessHours = [
  { day: "Segunda a Sexta", hours: "09:00 — 19:00" },
  { day: "Sábado", hours: "09:00 — 13:00" },
  { day: "Domingo", hours: "Fechado" },
];

export default function ContactSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="contato" className="py-20 md:py-32 bg-background-50">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 md:px-10 transition-all duration-1000 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="max-w-2xl mb-16">
          <p className="flex items-center gap-3 font-label text-[11px] md:text-xs uppercase tracking-[0.3em] text-primary-600 mb-6">
            <span className="w-10 h-[1px] bg-primary-500/60" />
            Agende seu horário
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-6 leading-tight">
            Pronta para{" "}
            <span className="italic font-normal text-primary-600">
              transformar
            </span>{" "}
            sua relação com a beleza?
          </h2>
          <p className="text-foreground-500 text-sm md:text-base font-light max-w-lg mb-8 leading-relaxed">
            Agende seu horário e venha viver a experiência Jennifer Siqueira
            Studio de Beleza
          </p>
          <a
            href="https://wa.me/5547991654435?text=Ol%C3%A1%20Jennifer%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio!"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-primary-500 hover:bg-primary-600 text-background-950 px-8 py-4 rounded-md text-[13px] font-label font-medium uppercase tracking-[0.14em] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center"></i>
            Agendar via WhatsApp
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:h-[560px]">
          <div className="bg-background-950 rounded-2xl p-8 md:p-10 lg:h-full border border-primary-500/15">
            <h3 className="font-heading text-xl font-semibold text-background-50 mb-8">
              Informações
            </h3>

            <div className="space-y-7">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full border border-primary-500/30 flex items-center justify-center text-primary-300 flex-shrink-0">
                  <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <p className="font-label text-[11px] uppercase tracking-[0.16em] text-primary-300 mb-2">
                    Endereço
                  </p>
                  <p className="text-sm text-background-100/75 font-light leading-relaxed">
                    Rua João José de Souza, 223 — Studio a esquina
                    <br />
                    Bairro Fortaleza — Blumenau/SC
                    <br />
                    CEP 89056-230
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full border border-primary-500/30 flex items-center justify-center text-primary-300 flex-shrink-0">
                  <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <p className="font-label text-[11px] uppercase tracking-[0.16em] text-primary-300 mb-2">
                    WhatsApp
                  </p>
                  <a
                    href="https://wa.me/5547991654435"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-background-100/85 hover:text-primary-300 font-light transition-colors duration-300 inline-block"
                  >
                    (47) 99165-4435
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full border border-primary-500/30 flex items-center justify-center text-primary-300 flex-shrink-0">
                  <i className="ri-instagram-line w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <p className="font-label text-[11px] uppercase tracking-[0.16em] text-primary-300 mb-2">
                    Instagram
                  </p>
                  <a
                    href="https://www.instagram.com/jennifersiqueirastudio/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-background-100/85 hover:text-primary-300 font-light transition-colors duration-300 inline-block"
                  >
                    @jennifersiqueirastudio
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full border border-primary-500/30 flex items-center justify-center text-primary-300 flex-shrink-0">
                  <i className="ri-time-line w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div className="flex-1">
                  <p className="font-label text-[11px] uppercase tracking-[0.16em] text-primary-300 mb-3">
                    Horários de Atendimento
                  </p>
                  <div className="space-y-2">
                    {businessHours.map((item) => (
                      <div
                        key={item.day}
                        className="flex items-center justify-between text-sm"
                      >
                        <span className="text-background-100/65 font-light">
                          {item.day}
                        </span>
                        <span
                          className={`font-label text-[12px] ${
                            item.hours === "Fechado"
                              ? "text-background-100/35"
                              : "text-background-50"
                          }`}
                        >
                          {item.hours}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <figure className="relative rounded-2xl overflow-hidden h-[420px] lg:h-full bg-background-200">
            <img
              src="https://storage.helloreaddy.io/project_files/070cccc1-78ba-4f09-b9b4-7fe0d725f057/b8bd11fe-b5c0-4362-9772-394c560e3611_compressed_7E8BF52C-0FB7-4D98-B947-B37FE20EE148.webp"
              alt="Fachada do studio Jennifer Siqueira Studio de Beleza no número 223"
              title="Fachada José de Souza Studio de Beleza Blumenau"
              className="w-full h-full object-cover object-center"
            />
            <figcaption className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/80 to-transparent px-5 py-4">
              <span className="text-background-50 text-xs md:text-sm font-label uppercase tracking-[0.12em]">
                Studio a esquina — nº 223
              </span>
            </figcaption>
          </figure>

          <div className="rounded-2xl overflow-hidden h-[360px] lg:h-full bg-background-200 border border-background-200">
            <iframe
              src="https://maps.google.com/maps?q=Rua+Jo%C3%A3o+Jos%C3%A9+de+Souza+223+Blumenau+SC+89056-230&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Jennifer Siqueira Studio de Beleza"
              className="w-full h-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
}